import React from 'react';
import { Months } from '../../../../../Enum/Months';

interface Props {
    value: number;
}

export const Month: React.FC<Props> = ({ value }: Props) => <>
    {value === 1 && Months.January}
    {value === 2 && Months.February}
    {value === 3 && Months.Maart}
    {value === 4 && Months.April}
    {value === 5 && Months.Mei}
    {value === 6 && Months.Juni}
    {value === 7 && Months.Juli}
    {value === 8 && Months.Augustus}
    {value === 9 && Months.September}
    {value === 10 && Months.Oktober}
    {value === 11 && Months.November}
    {value === 12 && Months.December}
</>;
